'use strict';

var Radio = require('backbone.radio');
var polyglot = require('../../utilities/polyglot').default;

var StepView = require('./step').default;
var TitleView = require('../step-title').default;
var ServiceListView = require('../services/service-list').default;
var CategoryListView = require('../services/category-list').default;
var SelectedServiceListView = require('../services/selected-service-list').default;
var EmptyView = require('../services/service-list-empty').default;
var LoadingView = require('../loading').default;
var LanguagesCollection = require('../../collections/languages').default;

export default StepView.extend({

  className: 'l-service-step',
  template: require('./templates/service.hbs'),

  regions: function() {
    return {
      title: '.' + this.className + '-title',
      loading: '.' + this.className + '-loading',
      uncategorized: '.' + this.className + '-uncategorized',
      categories: '.' + this.className + '-categories',
      selected_list: '.' + this.className + '-selected-list',
    };
  },

  initialize: function(options) {
    if (options) {
      if (options.times) {
        this.times = options.times;
      }
      if (options.staff) {
        this.staff = options.staff;
      }
    }
    this.languages = new LanguagesCollection(window.LANGUAGES);

    this.titleView = new TitleView({
      title: polyglot.t('pages.services.long_title'),
    });

    var self = this;
    this.listView = new ServiceListView({
      collection: this.collection,
      appointment: this.appointment,
      filter: function(child, index, collection) {
        return !self.appointment.isPrivate() && child.isUncategorized();
      },
    });

    this.categoryView = new CategoryListView({
      appointment: this.appointment,
      services: this.collection,
    });

    this.selectedListView = new SelectedServiceListView({
      collection: this.collection,
      appointment: this.appointment,
    });

    if (this.collection.length === 1) {
      this.appointment.addService(this.collection.models[0]);
    }

    this.listenTo(this.collection, 'reset sync', this.onCollectionReset);
    this.listenTo(this.listView, 'childview:click:checkbox', this.onClickService);
    this.listenTo(this.categoryView, 'childview:click:service', this.onClickCategoryService);
    this.listenTo(this.selectedListView, 'childview:close', this.onClickSelectedServiceClose);

    if (!Radio.channel('steps').request('first', polyglot.t('pages.services.slug'))) {
      this.loadingView = new LoadingView();
      this.loadingView.show();

      var data = {
        location_id: this.appointment.get('location_id'),
      };

      if (window.STAFF && this.appointment.get('staff_id')) {
        data.staff_id = this.appointment.get('staff_id');
      }

      if (window.CATEGORY) {
        data.category_id = window.CATEGORY.id;
      }

      data.lang = this.languages.getCurrent();

      var self = this;
      this.collection.fetch({
        data: data,
        success: function() {
          self.loadingView.hide();
        },
        error: function() {
          self.loadingView.hide();
        },
      });
    } else {
      this.showCookieMessage();
    }
  },

  onRender: function() {
    this.getRegion('title').show(this.titleView);
    if (this.collection.length === 0 || this.appointment.isPrivate()) {
      this.getRegion('uncategorized').show(new EmptyView());
    } else {
      this.getRegion('uncategorized').show(this.listView);
      this.getRegion('categories').show(this.categoryView);
    }
    this.getRegion('selected_list').show(this.selectedListView);

    if (this.loadingView) {
      this.getRegion('loading').show(this.loadingView);
    }
  },

  onDomRefresh: function() {
    if (this.listView.hasChildren()) {
      this.listView.focus();
    } else {
      this.categoryView.focus();
    }
  },

  onCollectionReset: function() {
    if (this.collection.length == 1) {
      this.appointment.addService(this.collection.at(0));
    }
  },

  onClickCategoryService: function(serviceView) {
    this.onClickService(serviceView);
  },

  onClickService: function(view) {
    if (view.isSelected()) {
      this.appointment.addService(view.model);
    } else {
      this.appointment.removeService(view.model);
    }

    if (!window.LOCATION && !this.appointment.hasPreferredLocation() && window.SETTINGS.first_step === 'service'
        && !window.SETTINGS.hide_location_step) {
      this.appointment.unsetLocation();
    }

    if (this.times && this.times.length) {
      this.times.reset();
    }

    if (this.staff && this.staff.length) {
      this.staff.reset();
    }

  },

  onClickSelectedServiceClose: function(args) {
    this.appointment.removeService(args.model);
  },

});
